import React from "react";
import { useTranslation } from 'react-i18next';
import { FaWhatsapp } from 'react-icons/fa';
import "./ConvertrexSection.css";
import exampleImage from "../assets/ads.png";

const ConvertrexSection = () => {
  const { t } = useTranslation();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá, gostaria de realizar um orçamento!');
    window.open(`https://wa.me/5511989887113?text=${message}`, '_blank');
  };

  return (
    <section className="convertrex-section">
      <div className="container">
        <div className="convertrex-content">
          <div className="convertrex-image">
            <img src={exampleImage} alt={t('convertrex.imageAlt')} />
            <div className="image-overlay"></div>
          </div>
          <div className="convertrex-text">
            <h2 className="section-title">
              {t('convertrex.title')}
            </h2>
            <p className="section-subtitle">
              {t('convertrex.subtitle')}
            </p>
            <div className="convertrex-cta">
              <button onClick={handleWhatsAppClick} className="convertrex-button">
                <FaWhatsapp />  {t('convertrex.cta')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConvertrexSection;